module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('title.next-schedule')))]), _vm._v(" "), _c('data-form', {
    attrs: {
      "fields": _vm.fields,
      "entity": _vm.formModel,
      "hideButtons": true
    },
    on: {
      "submit": _vm.setupTime
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('title.pending-jobs')))]), _vm._v(" "), _c('data-table', {
    attrs: {
      "model": "scheduled-jobs",
      "columns": ['id'],
      "plus-cells": ['payloadCell'],
      "operations": _vm.operations
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('title.remove'),
      "visible": !!_vm.modelToDelete,
      "width": "30%",
      "before-close": function () {
        _vm.modelToDelete = null
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('remove.message')))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.modelToDelete = null
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.deleteModel
    }
  }, [_vm._v(_vm._s(_vm.$t('button.confirm')))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a2936f6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scheduled-job/ScheduledJobPanel.vue
// module id = 1152
// module chunks = 2